import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import EventInterestsApi from '@infrastructure/event-interests-api';
export const createEventInterestAsync = createAsyncThunk('eventInterests/create', async (payload, { rejectWithValue }) => {
    try {
        const response = await EventInterestsApi.createEventInterest(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateEventInterestAsync = createAsyncThunk('eventInterests/update', async (payload, { rejectWithValue }) => {
    try {
        const response = await EventInterestsApi.updateEventInterest(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteEventInterestAsync = createAsyncThunk('eventInterests/delete', async (id, { rejectWithValue }) => {
    try {
        const response = await EventInterestsApi.deleteEventInterest(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEventInterestByIdAsync = createAsyncThunk('eventInterests/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await EventInterestsApi.getEventInterestById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getEventInterestsByEventIdAsync = createAsyncThunk('eventInterests/getByEventId', async (payload, { rejectWithValue }) => {
    try {
        const response = await EventInterestsApi.getEventInterestsByEventId(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
